import {post} from '../../../../util/api'
import { createChangeTableSettingAction } from '../../../form/state/table-state-helper'
import * as type from './type'
import * as tableAction from '../../../table/state/action'
import {selectOwnState, selectTable} from './selector'
import {TABLE_ALL_OPEN_TASK, TABLE_PROCESS_WORKLIST} from "./type";

export const initialTableQuery = tableAction.createInitialTableQueryAction(selectOwnState, type.TABLE_ALL_OPEN_TASK)

export const changeFilter = tableAction.createChangeFilterAction(selectOwnState, type.TABLE_ALL_OPEN_TASK)

export const toggleSort = tableAction.createToggleSortAction(selectOwnState, type.TABLE_ALL_OPEN_TASK)

export const toggleMultiSort = tableAction.createToggleMultiSortAction(selectOwnState, type.TABLE_ALL_OPEN_TASK)

export const gotoPage = tableAction.createGotoPageAction(type.TABLE_ALL_OPEN_TASK)

export const initialColumnsVisibility = tableAction.createInitialColumnsVisibilityFormHandler(TABLE_PROCESS_WORKLIST, type.CHANGE_TABLE_SETTING)

export const toggleColumnVisibility = tableAction.createToggleColumnVisibilityFormHandler(selectOwnState, type.CHANGE_TABLE_SETTING, TABLE_PROCESS_WORKLIST)

export const initialTableSettingsAllOpenTask = tableAction.createInitialColumnsVisibilityTableHandler(TABLE_ALL_OPEN_TASK)

export const toggleColumnVisibilityAllOpenTask = tableAction.createToggleColumnVisibilityTableHandler(selectTable, TABLE_ALL_OPEN_TASK)

export const changeTableSetting = createChangeTableSettingAction(type.CHANGE_TABLE_SETTING)

export const findTaskListRequest = () => ({
    type: type.FIND_TASK_LIST_REQUEST,
    payload: {},
})

export const findTaskListSuccess = (taskList) => ({
    type: type.FIND_TASK_LIST_SUCCESS,
    payload: {
        taskList,
    },
})

export const findPTaskListError = (error) => ({
    type: type.FIND_TASK_LIST_ERROR,
    payload: {
        error,
    },
})

export const findTaskList = () => (dispatch) => {
    dispatch(findTaskListRequest())

    post('/api/process/task/find-open')
        .then(taskList => {
            dispatch(findTaskListSuccess(taskList))
        })
        .catch(error => {
            dispatch(findPTaskListError(error))
        })
}






// WEBPACK FOOTER //
// ./src/modules/process/state/task-list/action.js